import Button from "components/atoms/Button/Button";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useQueryClient } from "@tanstack/react-query";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { clearFiltersFromLocalStorage } from "helpers/localStorage";
import Alert from "../Alert/Alert";

function LoggedInAsBanner({ loggedInAsUserName, isLoggedInAs, setIsLoggedInAs, clearLocale }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [isBannerVisible, setIsBannerVisible] = useState(isLoggedInAs);

  useEffect(() => setIsBannerVisible(isLoggedInAs), [isLoggedInAs]);

  const logout = () => {
    setIsLoggedInAs(false);
    clearFiltersFromLocalStorage();
    clearLocale();
    Cookies.remove("cargobase_logged_in_as_token");
    queryClient.clear();
    navigate(`/`);
  };

  const styles = {
    zIndex: 5,
    position: "fixed",
    width: "100%",
    bottom: 0,
    transition: "opacity .3s",
    backgroundColor: "#feeeec",
  };

  if (!isBannerVisible || !loggedInAsUserName) return null;

  return (
    <div style={styles} className="hide-during-print">
      <Alert variant="warning">
        <div className="d-flex align-items-center text-warning login-as-warning">
          <FormattedMessage
            id="components.molecules.logged-in-as-banner.loggedInAs"
            defaultMessage="You are currently logged in as"
          />{" "}
          {loggedInAsUserName} |
          <Button
            variant="link"
            onClick={logout}
            label={
              <FormattedMessage
                id="components.molecules.logged-in-as-banner.returnToStaffUI"
                defaultMessage="Return to Staff UI"
              />
            }
            className="pl-1"
          />
        </div>
      </Alert>
    </div>
  );
}

LoggedInAsBanner.propTypes = {
  loggedInAsUserName: PropTypes.string,
  isLoggedInAs: PropTypes.bool.isRequired,
  setIsLoggedInAs: PropTypes.func.isRequired,
  clearLocale: PropTypes.func.isRequired,
};

LoggedInAsBanner.defaultProps = {
  loggedInAsUserName: null,
};

export default LoggedInAsBanner;
